export default __webpack_public_path__ + "static/VIRSAT-Life-Saving-Rules-Aware-2c77d6dd3ad5c3717e48037145762ac9.jpg";